module.exports = __webpack_public_path__ + "img/angel-4704518_1280_thumb.814a73eb.png";